export default "__VITE_ASSET__Bjk8mrfA__"